import { DataServiceModule } from 'services/data/data.service';
import { AppSettingsModule } from 'services/settings.provider';

export const PaymentMethodServiceModule = angular
    .module('app.services.payment.paymentMethod', [
        DataServiceModule,
        AppSettingsModule
    ])
    .service('paymentMethodService', (
        dataService,
        settings
    ) => {
        function getPaymentMethod() {
            return dataService.getAll(settings.api.paymentMethod);
        }

        function updatePaymentMethod(creditCardToken) {
            return dataService.saveAll(settings.api.paymentMethod, { creditCardToken });
        }

        return {
            getPaymentMethod,
            updatePaymentMethod
        };
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/payment/paymentMethod/paymentMethod.service.js